<template>
  <div class="view contentBody">
    <div class="title">雷达权限管理</div>
    <!--<div class="content contentBody">-->
    <div class="radar_other">
      <div class="compay">
        <span class="choosedep mr-10 companyInfo" v-if="partmentTitle">
          {{partmentTitle}}
          <!--({{aprtment_number}})-->
        </span>
        <el-button @click="choosedep" size="small">{{department}}</el-button>
      </div>
      <div class="ercode_wrap">
        <div class="ercode appbox appBlock">
          <i class="iconfont iconerweima"></i>造像时代APP
          <div class="dowloadApp loadApp">
            <img src="/static/admin-img/yunzhiApp.png" alt="" class="img">
            <p>扫码下载APP</p>
          </div>
        </div>
        <div class="ercode appbox moreBlock">
          <i class="iconfont iconerweima"></i>造像时代
          <div class="dowloadApp lookMore">
            <img src="https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/zxgpc/images/20230826/9834ebdbc4cdc513fa3f4e7cd8f3e895.jpg" alt="" class="img">
            <p>扫码查看更多</p>
          </div>
        </div>
      </div>
      <div class="on_wrap">
        已开通：<i>{{openNumber}}</i>
        <span @click="applyOpen">申请扩容</span>
      </div>
    </div>
    <div class="condition">
      <div class="search_wrap">
        <el-form :inline="true" class="form-inline">
          <el-form-item>
            <el-input v-model="form.name" placeholder="请输入姓名搜索" size="small"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="searchName" size="small"></el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="other_wrap">
        <span>尚有{{activeApp}}人未激活APP</span>
        <el-button @click="getAppCode" size="small">一键邀请激活APP</el-button>
        <el-button @click="batchopen" size="small">批量开通</el-button>
      </div>
    </div>
    <div class="table_wrap">
      <el-table :data="tableData"
                style="width: 100%">
        <el-table-column label="头像" width="100" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.pic" alt="" width="60" height="60">
          </template>
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="120" align="center"></el-table-column>
        <el-table-column prop="position" label="职务" align="center"></el-table-column>
        <el-table-column prop="department" label="部门" align="center"></el-table-column>
        <el-table-column prop="phone" label="手机" align="center">
        </el-table-column>
        <el-table-column prop="address" label="AI雷达和名片" align="center">
          <template slot-scope="scope">
            <el-switch
                    v-model="scope.row.switch_ai_radar"
                    active-color="#2AA3F8"
                    inactive-color="#ddd"
                    @change="changeswitch('ai_radar',scope.$index)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="BOSS数据中台" align="center">
          <template slot-scope="scope">
            <el-switch
                    v-model="scope.row.switch_boss_radar"
                    active-color="#2AA3F8"
                    inactive-color="#ddd"
                    @change="changeswitch('boss_radar',scope.$index)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="APP" align="center">
          <template slot-scope="scope">
            <!--"app_status":"APP状态(0未激活、1已激活)",-->
            <span :class="scope.row.app_status!==1?'red':''">{{scope.row.app_status==1?'已激活':'未激活'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <span @click="qrcode(scope.row)" class="action_btn">导出二维码</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pag_wrap">
        <el-pagination
                background
                @current-change="pageIndexChange"
                :page-size="page.pagesize"
                :current-page="page.pageindex"
                layout="total, prev, pager, next"
                :total="page.total"
        ></el-pagination>
      </div>
    </div>
    <!--</div>-->
    <chooseDepDialog
            :visible.sync="choosedepdialog"
            v-if="choosedepdialog"
            @choosedepsucess="choosedepsucess"
    ></chooseDepDialog>
    <QRcodeDialog :visible.sync="qrcodedialog" v-if="qrcodedialog" :qrcodeId="qrcodeId" :username="username"
                  :qrcodeType="qrcodeType"></QRcodeDialog>
    <batchOpenDialog :visible.sync="batchopendialog" v-if="batchopendialog" @submitFn="submitFn"></batchOpenDialog>
  </div>
</template>
<script>
  import api from "@/api.js";
  import chooseDepDialog from "@/components/dialog/chooseDepDialog.vue";
  import QRcodeDialog from "@/components/dialog/QRcodeDialog.vue";
  import batchOpenDialog from "@/components/dialog/batchOpenDialog.vue";
  import {pagination} from "@/util/util.js";

  export default {
    name: "roles",
    components: {
      chooseDepDialog,
      QRcodeDialog,
      batchOpenDialog
    },
    data() {
      return {
        tableData: [],
        choosedepdialog: false,
        qrcodedialog: false,
        qrcodeType: 1, // 1 角色员工二维码 2 推广二维码
        batchopendialog: false,
        department: '选择部门',
        qrcodeId: '',
        form: {
          page: 1,
          name: "",
          depart_id: ""
        },
        username: '',
        partmentTitle: '',
        allpage: 1,
        openNumber: 0,
        activeApp:0,
        page: {
          pageindex: pagination.pageIndex,
          pagesize: pagination.pageSize,
          total: pagination.total
        },
        // aprtment_number: 0, // 部门人数
        // aprtment_unactive: 0 // 未开通雷达人数
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        // page 	整型 	必填 	- 	- 	页码
        // name 	整型 	必填 	- 	- 	员工名称搜索
        // depart_id 	整型 	必填 	- 	- 	部门id
        let params = {
          page: this.page.pageindex,
          name: this.form.name,
          depart_id: this.form.depart_id
        };
        this.axios
            .post(api.radar_index, params)
            .then(response => {
              if (response.data.code == 0) {
                // "ai_radar":"AI雷达和名片状态(0关闭、1开启)"
                // "boss_radar":"BOSS数据中台状态(0关闭、1开启)"
                for (let i in response.data.list) {
                  let ai_radar = false
                  if (Number(response.data.list[i].ai_radar) === 1) {
                    ai_radar = true
                  }
                  let boss_radar = false
                  if (Number(response.data.list[i].boss_radar) === 1) {
                    boss_radar = true
                  }
                  response.data.list[i].switch_ai_radar = ai_radar;
                  response.data.list[i].switch_boss_radar = boss_radar;
                }
                this.tableData = response.data.list
                this.page.total = response.data.all_page
                // this.aprtment_number = response.data.number // 部门人数
                // this.aprtment_unactive = response.data.unactive // 未开通雷达人数
                this.openNumber = response.data.open_number;
                this.activeApp = response.data.unactive
              } else {
              }
            })
            .catch(response => {
            });
      },
      pageIndexChange(pageindex) {
        this.page.pageindex = pageindex;
        this.InitFn();
      },
      searchName() {
        this.form.page = 1
        this.InitFn()
      },
      submitFn() {
        this.InitFn();
      },
      // 选择部门
      choosedep() {
        this.choosedepdialog = true;
      },
      choosedepsucess(val) {
        this.partmentTitle = val.name
        this.form.depart_id = val.id
        this.InitFn()
      },
      // 二维码
      qrcode(e) {
        this.username = e.name
        this.qrcodeId = e.id
        this.qrcodedialog = true;
      },
      getAppCode() {
        this.axios
            .post(api.radar_invite, {})
            .then(response => {
              if (response.data.code == 0) {
                this.$confirm('消息已经发出，如果有还未下载的同事，下次登录时系统会再次通知你', '提示', {
                  confirmButtonText: '我知道了',
                  showCancelButton: false,
                  type: 'warning'
                }).then(() => {
                }).catch(() => {
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      // 批量开通
      batchopen() {
        this.batchopendialog = true;
      },
      applyOpen() {
        this.$confirm('如需开通新的AI名片,可以联系你的代理商或者账号开通人升级造像时代系统套餐', '提示', {
          confirmButtonText: '我知道了',
          showCancelButton: false,
          type: 'warning'
        }).then(() => {
        }).catch(() => {
        });
      },
      changeswitch(type, index) {
        // ('ai_radar',scope.$index) ('boss_radar',scope.$index)
        let params = {
          em_id: this.tableData[index].id
        };
        //  AI雷达和名片
        if (type === 'ai_radar') {
          if (this.tableData[index].switch_ai_radar) {
            this.tableData[index].switch_ai_radar = !this.tableData[index].switch_ai_radar
            params.open_status = 1 // 开启状态(0关闭、1开启)
            this.$confirm('确认为' + this.tableData[index].name + '开通"AI雷达和名片"?', '开通AI雷达和名片', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              const loading = this.$loading({
                lock: true,
                text: '设置中…',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
              });
              this.aiRadar(index, params, loading)
            }).catch(() => {
            });
          } else {
            this.tableData[index].switch_ai_radar = !this.tableData[index].switch_ai_radar
            params.open_status = 0 // 开启状态(0关闭、1开启)
            this.$confirm('确认停用' + this.tableData[index].name + '的"AI雷达"和"BOSS数据中台"?', '停用AI雷达和名片', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              const loading = this.$loading({
                lock: true,
                text: '设置中…',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.4)',
          customClass:'fontColor'
              });
              this.aiRadar(index, params, loading)
            }).catch(() => {
            });
          }
        }
        // BOSS雷达
        if (type === 'boss_radar') {
          if (this.tableData[index].switch_boss_radar) {
            // 开通
            params.open_status = 1; // 开启状态(0关闭、1开启)
            let title = '确认为' + this.tableData[index].name + '开通"BOSS数据中台"?'
            if (!this.tableData[index].switch_ai_radar) {
              title = '开通"BOSS数据中台"需要先开通"AI雷达和名片",确认为' + this.tableData[index].name + '同时开通"AI雷达和名片"?'
            }
            this.tableData[index].switch_boss_radar = !this.tableData[index].switch_boss_radar
            this.$confirm(title, '开通BOSS数据中台', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.bossRadar(index, params)
            }).catch(() => {
              // this.tableData[index].switch_boss_radar = false
            });
          } else {
            // 关闭
            params.open_status = 0 // 开启状态(0关闭、1开启)
            this.tableData[index].switch_boss_radar = !this.tableData[index].switch_boss_radar
            this.$confirm('如果停用"BOSS数据中台"，"AI雷达和名片"可正常使用,确认停用' + this.tableData[index].name + '的"BOSS数据中台"?停用后该用户将无法查看BOSS数据中台的相关数据。', '停用BOSS数据中台', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.bossRadar(index, params)
            }).catch(() => {
              // this.tableData[index].switch_boss_radar = true
            });
          }
        }
      },
      aiRadar(index, params, loading) {
        // open_status 	整型 	必填 	- 	- 	开启状态(0关闭、1开启)
        // em_id 	整型 	必填 	- 	- 	员工id
        this.axios
            .post(api.radar_ai, params)
            .then(response => {
              if (response.data.code === 0) {
                this.tableData[index].switch_ai_radar = !this.tableData[index].switch_ai_radar
                if (!this.tableData[index].switch_ai_radar) {
                  this.tableData[index].switch_boss_radar = false
                }
                loading.close();
              } else {
                loading.close();
                this.$confirm(response.data.msg, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  type: 'warning'
                }).then(() => {
                }).catch(() => {
                });
              }
            })
            .catch(response => {
            });
      },
      bossRadar(index, params) {
        // open_status 	整型 	必填 	- 	- 	开启状态(0关闭、1开启)
        // em_id 	整型 	必填 	- 	- 	员工id
        this.axios
            .post(api.radar_boss, params)
            .then(response => {
              if (response.data.code == 0) {
                if (params.open_status === 1) {
                  this.$confirm('AI雷达和名片开通成功!', '提示', {
                    confirmButtonText: '确定',
                    showCancelButton:false,
                    type: 'success'
                  }).then(() => {
                  }).catch(() => {
                  });
                }
                this.InitFn()
              } else {
                this.$confirm(response.data.msg, '提示', {
                  confirmButtonText: '确定',
                  showCancelButton: false,
                  type: 'warning'
                }).then(() => {
                }).catch(() => {
                });
              }
            })
            .catch(response => {
            });
      },
    }
  };
</script>
